<template>
  <div class="container">
    <Head  :title="courseData.courseTitle"></Head>
    <div class="test-img">
        <img src="@/assets/img/placeholder.png" v-if="courseData.thumb == null"  alt />
        <img :src="courseData.thumb"   v-if="courseData.thumb" alt  />
    </div>
    <div class="test-info-box">
      <div class="info-item">
        <span>试卷详情：</span>
        <span>{{examination.examinationName}}</span>
      </div>
      <div class="info-item">
        <span>考试时长:</span>
        <span>{{getDuration(examination.testTime)}}</span>
      </div>
      <div class="info-item">
        <span>试题数量：</span>
        <span>{{examination.questionCount}}题</span>
      </div>
      <div class="info-item">
        <span>及格线：</span>
        <span>{{examination.pass*100}}% （简答题不在计算范围</span>
      </div>
      <div class="info-item">
        <span>出题规则：</span>
        <span>{{examination.keywords}}</span>
      </div>
    </div>
    <div class="back"   @click="back">我再想想，先返回</div>
    <div class="gotest" v-if="actionType === 1"  @click="gotest(1)">开始测试</div>
    <div class="gotest" v-if="actionType === 2"  @click="goResult">查看考试结果</div>
    <div class="gotest" v-if="actionType === 2"  @click="goParsing">查看解析</div>
    <div class="gotest" v-if="actionType === 2"  @click="gotest(1)">重新测试</div>
    <div class="gotest" v-if="actionType === 3"  @click="gotest(3)">继续测试</div>
    <div class="gotest" v-if="actionType === 3"  @click="gotest(1)">重新测试</div>
  </div>
</template>
<script>
import Head from '@/components/h5/Head'
import * as dateUtil from '@/api/dateUtil'
export default {
  name: "StartTest",
  data () {
    return {
        courseData: {}, //课程详细
        actionType: '', //类型  1:开始答题    2重新答题     3 继续答题   
        examination: '', //试卷详细
    };
  },
  components: {
    Head
  },
created(){
    //从课程详细页面答题跳转此页面
    console.log('data',this.$route.params)
    console.log('courseData',this.$route.params.courseData)
    if (this.$route.params.toStartTestdata) {
     this.examination=  this.$route.params.examination
     this.courseData = this.$route.params.courseData
     this.actionType=this.$route.params.actionType
    } else {
     this.examination=JSON.parse(sessionStorage.getItem('startTestMobile')).examination
     this.courseData = JSON.parse(sessionStorage.getItem('startTestMobile')).courseData
     this.actionType=JSON.parse(sessionStorage.getItem('startTestMobile')).actionType
    }
},
  methods: {
    back(){
        this.$router.back()
    },
//查看考试结果
  goResult(){
     this.examination.customerExaminationTestLogId=this.examination.customerExaminationTestLogEntity.customerExaminationTestLogId
     this.examination.courseName=this.courseData.courseName
     this.examination.home = 1
     this.$router.push({
        name: 'ResultPage',
       params: this.examination
      })
   sessionStorage.setItem('resultPage', JSON.stringify(this.examination))
  },
  //查看解析
  goParsing(){
      this.examination.courseName=this.courseData.courseName
      this.$router.push({
        name: 'ParsingPage',
        params: this.examination
      })
      sessionStorage.setItem('parsingPage', JSON.stringify(this.examination))
  },
      //开始答题
    gotest(actionType){
     this.examination.courseName=this.courseData.courseName
      let data = {
        examination: this.examination,
        actionType: actionType
      }
      setTimeout(() => {
        this.$router.push(
          {
            name: 'AnswerPage',
            params: data
          }
        )
        sessionStorage.setItem('answerPage', JSON.stringify(data))
      }, 200)
    },
    //时间转换
    getDuration (val) {
      if (val) {
        return dateUtil.getDuration(val)
      }
    }
  },
}
</script>
<style lang="less" scoped>
.container {
  background-color: #ffffff;
}
.test-img {
  margin: 18px 15px;
  img {
    width: 100%;
  }
}
.test-info-box {
  margin: 15px 35px;
  .info-item {
    display: flex;
    line-height: 30px;
    font-size: 14px;
    span {
      &:first-child {
        width: 90px;
        flex-shrink: 0;
      }
    }
  }
}
.back {
  margin: 50px auto 0;
  width: 270px;
  height: 35px;
  line-height: 35px;
  background: rgba(249, 249, 249, 1);
  border-radius: 8px;
  color: #010101;
  text-align: center;
}
.gotest {
  margin: 20px auto 0;
  width: 270px;
  height: 35px;
  line-height: 35px;
  background: linear-gradient(
    -3deg,
    rgba(74, 199, 255, 1),
    rgba(77, 167, 249, 1)
  );
  border-radius: 8px;
  color: #ffffff;
  text-align: center;
}
</style>